import { apiClient } from './client'

/**
 * Fetch all subscription types from the backend.
 */
export async function getSubscriptions() {
  return apiClient('/subscriptions')
}

/**
 * Fetch a single subscription by slug from the backend.
 */
export async function getSubscriptionById(id) {
  return apiClient(`/subscriptions/${id}`)
}

/**
 * Fetch all recurring (monthly) subscriptions from the backend.
 */
export async function getRecurringSubscriptions() {
  return apiClient('/subscriptions?recurring=true')
}

/**
 * Fetch all subscriptions that can be bought as gifts from the backend.
 */
export async function getGiftSubscriptions() {
  return apiClient('/subscriptions?giftable=true')
}

/**
 * Fetch subscriptions filtered by category from the backend.
 */
export async function getSubscriptionsByCategory(category) {
  return apiClient(`/subscriptions?category=${encodeURIComponent(category)}`)
}
